import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class FocusBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.focus = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let focusable = ko.unwrap(valueAccessor());

                if (focusable)
                    element.attr('tabindex', 0);
                else
                    element.attr('tabindex', -1);
            }
        };
    }
}